import { LoadableAfterPaint } from '@confluence/loadable';

export const ContextualCreateContentPopoverMenuLoader = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ContextualCreateContentPopoverMenu" */ './ContextualCreateContentPopoverMenu'
			)
		).ContextualCreateContentPopoverMenu,
	_noPreloadWhenRenderingSPA: true,
});
